import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";
import { environmentDistanceFireStationLayerColors } from "../policy/policyMapStyle";
import { getEnvironmentDistanceFacilityDataLegend } from "../../lib/getEnvironmentDistanceFacilityData";

const EnvironmentDistanceSchoolLegend = ({ lng, lat }) => {
  const { t } = useTranslation();
  const [listOfLines, setListOfLines] = useState([]);
  const [noDataMsg, setNoDataMsg] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const result = await getEnvironmentDistanceFacilityDataLegend({ lng, lat }, "walkingFromSchool");
      console.log("result", result);

      setListOfLines(result.mapReport?.split("\n"));
      setNoDataMsg(result.noData || "");
    };
    fetchData();
  }, [lng, lat]);

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.environmentDistanceSchool")} </b>
      </div>
      {noDataMsg && <div>{noDataMsg}</div>}

      {listOfLines?.length > 0 &&
        Array.from(
          { length: Math.min(listOfLines.length, environmentDistanceFireStationLayerColors.length) },
          (_, i) => {
            const line = (listOfLines[i] || "").trim();
            if (!line) return null;
            return (
              <div key={i}>
                <span style={legendItemStyle(environmentDistanceFireStationLayerColors[i])}></span>
                {i + 1} {line}
              </div>
            );
          },
        )}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, OpenStreetMap contributors
        </span>
      </div>
    </div>
  );
};

export default EnvironmentDistanceSchoolLegend;
